import type { IContextQueryResult } from '@modules/core/services/query/types';
import { ARTICLES_PERMISSIONS } from '@modules/articles/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IDashboardArticle,
  IDashboardArticlesResponse,
} from '../types';
import {
  DASHBOARD_ARTICLES_QUERY_KEY,
  DASHBOARD_ARTICLES_URL,
} from '../constants';

export default function useDashboardArticlesQuery(): IContextQueryResult<IDashboardArticlesResponse, Error, IDashboardArticle[]> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IDashboardArticlesResponse, Error, IDashboardArticle[]>({
    queryKey: [DASHBOARD_ARTICLES_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet(DASHBOARD_ARTICLES_URL, {
      signal,
      permission: ARTICLES_PERMISSIONS.SHOW,
    }),
    select: (res) => res.list_articles,
  });
}
